import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData } from '../Services/api';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const ContactTypeList = () => {
    const [contactTypes, setContactTypes] = useState([]);

    const fetchContacts = async () => {
        try {
            const res = await getData('/contacttypes');
            if (res.status) {
                setContactTypes(res.data || [])
            }
        } catch (error) {
            console.log("error fetch contacttypes", error)
        }
    }

    useEffect(() => {
        fetchContacts();
    }, []);


    const handleDelete = (cId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/contacttypes/delete/${cId}`,);
                    if (res.status) {
                        toast.success(res.message);
                        fetchContacts();
                    }
                } catch (error) {
                    console.log("error delete contacts", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/contacttypes/contacttype-list">Contact Types</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Contact Types
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Contact Types</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="text-end p-4 pb-sm-2">
                                    <Link to="/contacttypes/add-contacttype"
                                        className="btn btn-primary d-inline-flex align-item-center"
                                    >
                                        <i className="fas fa-plus f-18 mx-2" /> Add Contact Type
                                    </Link>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Name</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    contactTypes?.length > 0 ? (
                                                        contactTypes?.map((contact, index) => {
                                                            return (
                                                                <tr key={contact.id}>
                                                                    <td>{index + 1}.</td>
                                                                    <td>
                                                                        <h6 className="mb-0">{contact.name}</h6>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="View"
                                                                            >
                                                                                <Link
                                                                                    to={`/contacttypes/view-contacttype/${contact.id}`}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-eye f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Edit"
                                                                            >
                                                                                <Link
                                                                                    to={`/contacttypes/update-contacttype/${contact.id}`}
                                                                                    className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-edit f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="View"
                                                                            >
                                                                                <button
                                                                                    onClick={() => handleDelete(contact.id)}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-trash f-18" />
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td className='text-center' colSpan={5}><strong>No Data Found.</strong></td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactTypeList
